import script from "./bridge.vue?vue&type=script&setup=true&lang=js"
export * from "./bridge.vue?vue&type=script&setup=true&lang=js"

import "./bridge.vue?vue&type=style&index=0&id=7b73581a&lang=less&scoped=true"

import exportComponent from "/Users/xyyw/code/company/web/sanroe-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b73581a"]])

export default __exports__